export const PAGE_TITLE = 'Subastas FRAL - Subastas desde 1985';
// RP_NAME is the name of the Relying Party (RP) for WebAuthn
export const RP_NAME = 'Subastas FRAL';

export const APP_SID = 'fral-sid';
export const APP_AUTH = 'fral-auth';
export const APP_AUTH_INFO = 'fral-auth-info';
export const APP_REG_INFO = 'fral-reg-info';
export const APP_TOS = 'fral-tos';
export const AUCTION_PAGE = 'auction-page';
export const DASHBOARD_AUCTIONS = 'dashboard-auctions';
export const DASHBOARD_LOTS = 'dashboard_lots';
export const DASHBOARD_LIVE = 'dashboard-live';
export const DASHBOARD_SETTINGS = 'dashboard-settings';
export const DASHBOARD_USERS = 'dashboard-users';
export const LOTS_PAGE = 'lots-page';
export const WORKFLOWS = 'workflows';
